export const technologyServices = [
  {
    slug: "web-applications",
    name: "Web Applications",
    route: "/technology/web-applications",
    seoTitle: "Web Application Development in Karaikudi | WE3X Technologies",
    seoDescription: "Custom web application development by WE3X Technologies for business workflows, operations, customers, data and teams.",
  },
  {
    slug: "landing-pages",
    name: "Landing Pages",
    route: "/technology/landing-pages",
    seoTitle: "Landing Page Development in Karaikudi | WE3X Technologies",
    seoDescription: "Conversion-focused landing page design and development by WE3X Technologies for clear offers, trust and meaningful action.",
  },
  {
    slug: "digital-marketing",
    name: "Digital Marketing",
    route: "/technology/digital-marketing",
    seoTitle: "Digital Marketing Services in Karaikudi | WE3X Technologies",
    seoDescription: "Digital marketing services from WE3X Technologies including search, campaigns, social media and audience growth.",
  },
  {
    slug: "mobile-apps",
    name: "Mobile Apps",
    route: "/technology/mobile-apps",
    seoTitle: "Mobile App Development in Karaikudi | WE3X Technologies",
    seoDescription: "Mobile application design and development by WE3X Technologies for customer-facing apps and internal business tools.",
  },
  {
    slug: "animated-websites",
    name: "Animated Websites",
    route: "/technology/animated-websites",
    seoTitle: "Animated Website Development in Karaikudi | WE3X Technologies",
    seoDescription: "Immersive animated website experiences with motion, storytelling and interaction by WE3X Technologies.",
  },
  {
    slug: "video-editing",
    name: "Video Editing",
    route: "/technology/video-editing",
    seoTitle: "Video Editing Services in Karaikudi | WE3X Technologies",
    seoDescription: "Professional video editing from WE3X Technologies combining footage, sound, pacing, motion and visual storytelling.",
  },
];

export const technologyServiceMap = Object.fromEntries(
  technologyServices.map((service) => [service.slug, service])
);
